import { FincasPlataformaService } from "../../generated/grpc/plataforma_terceros_fincas_pb";
import { SasReadUrlResponse } from "../../response/storage/SasReadUrlResponse";
import { grpcCall, grpcClient } from "../grpc/grpcCall";

/** Margen de seguridad: refrescamos el SAS 30 min antes de que expire, para
 *  no usar un token que caduque a mitad de carga de tiles. */
const EXPIRY_MARGIN_MS = 30 * 60_000;

/**
 * SAS de lectura (24 h, a nivel cuenta de storage) de los tiles de ortomosaico/conteo del mapa de la
 * finca (`FincasPlataformaService.GetSasLecturaTiles`, gRPC). Se cachea por sesión y se reutiliza hasta
 * que esté por expirar.
 */
class StorageTilesSasReadService {
  private _cached: SasReadUrlResponse | null = null;
  private _inFlight: Promise<SasReadUrlResponse> | null = null;

  /** SAS vigente (cacheado); pide uno nuevo si no hay o está por expirar. */
  async getAsync(): Promise<SasReadUrlResponse> {
    if (this._cached && !this._isExpiring(this._cached)) {
      return this._cached;
    }
    if (this._inFlight) return this._inFlight;

    this._inFlight = grpcCall(() => grpcClient(FincasPlataformaService).getSasLecturaTiles({}))
      .then((r) => {
        this._cached = { sasToken: r.sasToken, expiresOn: new Date(Number(r.expiresOn)).toISOString() };
        return this._cached;
      })
      .finally(() => {
        this._inFlight = null;
      });
    return this._inFlight;
  }

  /** true si el SAS vence dentro del margen de seguridad. */
  private _isExpiring(sas: SasReadUrlResponse): boolean {
    return new Date(sas.expiresOn).getTime() - Date.now() <= EXPIRY_MARGIN_MS;
  }
}

/** Singleton del servicio de SAS de lectura de tiles. */
export const storageTilesSasReadService = new StorageTilesSasReadService();
